<template lang="pug">
include /mixins
+b.date-range-filter
  +e.values
    v-selection-controller(
      :options='dates'
      :multiple='false',
      :key-getter="$options.keyGetter",
      v-model='date'
      ref='controller'
      v-slot="{ options, value: model, change }"
    )
      div
        +b.um-space_mt--3.date-range-value(
          v-for='{ value } in options'
        )
          +b.d-control-static-input--appearance_inline.TAG(
            :rules='{ required: { allowFalse: false } }',
            :tag='"input"'
            :checked.props='!!model.find(e => e && e.key == value.key)'
            :input-label='value.title'
            :key='`key_${value.key}`'
            v-model='model'
            :id='`date_range_${value.key}`'
            :ref='`date_range_${value.key}`'
            @change='change(value); setValue(value)'
            type='radio'
            name='special_offer'
          )
          label.input-group__input(
            :for='`date_range_${value.key}`'
          ) {{ value.title }}
  +e.instance
    d-control-date-range(
      :prepare='prepare'
      @input='submit'
      :range='filter && filter.values'
      v-model="checked"
      :params='params'
    )
</template>

<script>

import { add } from 'date-fns'

export default {
  name: 'DateRangeWidget',
  props: ['value', 'filter', 'available', 'params'],
  keyGetter: x => x.key,
  data() {
    return {
      checked: '',
      dates: [
        {
          key: 'future_3',
          value: 2,
          title: this._('Найближчі 3 дні'),
        },
        {
          key: 'future_7',
          value: 6,
          title: this._('Найближчі 7 днів'),
        },
        {
          key: 'future_14',
          value: 13,
          title: this._('Найближчі 14 днів'),
        },
        {
          key: 'future_28',
          value: 27,
          title: this._('Найближчий місяць'),
        },
      ],
      date: null,
    }
  },
  watch: {
    value(nval) {
      this.checked = this.normalizeFrom(nval)
    },
  },
  mounted() {
    this.checked = this.normalizeFrom(this.value)
  },
  methods: {
    setValue(value) {
      const after = new Date()
      const before = add(new Date(), {
        days: value.value,
      })
      this.checked = [after, before]
    },
    submit() {
      this.date = null
      const [startDate, endDate] = this.checked
      const newStartDate = new Date(this.prepare(startDate))
      const newEndDate = new Date(this.prepare(endDate))

      const isReversed = newStartDate > newEndDate

      const range = {
        after: isReversed ? endDate : startDate,
        before: isReversed ? startDate : endDate,
      }
      this.$emit('input:multiple', range)
    },
    normalizeTo(value) {
      if (!value) return []
      return this.checked
    },
    prepare(value) {
      try {
        const [d, m, y] = value.split('.')
        return `${m}.${d}.${y}`
      } catch (e) {
        return value
      }
    },
    normalizeFrom(value) {
      if (!value) return []
      const checked = []
      value.forEach(el => {
        if (Array.isArray(el)) {
          checked.push(el[0])
          return
        }
        checked.push(el)
      })
      return checked
    },
  },
}
</script>
